export const prettyUrl = (website: string) => {
  if (!website) return "";
  return website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0];
};
